import { signal } from '@preact/signals-react'

export const userProfileSignal = signal(null)
export const userProfileLoadedSignal = signal(false)
export const userProfileErrorSignal = signal(null)